import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox }}\n&mdash;",{ moduleName: "embercom/components/inbox2/conversations-table/table-cells/empty.hbs" })